import { Lista } from "./lista";
import { Item } from "./item";

export class Pedido {
    id: number;
    de: string;
    mensaje: string;
    lista: Lista;
    items: Array<Item> = [];

    total(): number {
        let total = 0;
        this.items.forEach(function (item) {
            total = total  + item.total();
        });
        return total;
    }
}